import { AlertBar2 } from "@/ui2/atoms/AlertBar";

export function ApprovalAlert() {
  return (
    <AlertBar2 variant="warning">
      <b className="tw:block">Approval required</b>
      This override request will need approval from a Care Team Chief or Supervisor before taking
      effect.
    </AlertBar2>
  );
}
